import type { FC } from 'react';

import { LocalizedLink } from '~/components/LocalizedLink';
import { Button } from '~/components/ui/button';
import { useLocaleNavigation } from '~/routes/hooks';

interface LocaleSwitcherProps {
  className?: string;
  linkClassName?: string;
  onSelect?: () => void;
}

export const LocaleSwitcher: FC<LocaleSwitcherProps> = ({
  className,
  linkClassName,
  onSelect,
}) => {
  const { availableLocales, locale, setLocale, pathWithoutLocale } =
    useLocaleNavigation();

  const handleLocaleChange = (newLocale: string) => {
    setLocale(newLocale);
  };

  // Filter to show only the "other" locale (not current)
  const otherLocales = availableLocales.filter((loc) => loc !== locale);

  return (
    <ol className={className ?? 'flex items-center gap-2'}>
      {otherLocales.map((loc) => (
        <li key={loc}>
          <Button
            asChild
            variant="default"
            size="sm"
            className={
              linkClassName}
          >
            <LocalizedLink
              onClick={(event) => {
                event.preventDefault();
                handleLocaleChange(loc);
                onSelect?.();
              }}
              to={pathWithoutLocale as string}
              localeOverride={loc}
            >
              {loc.toUpperCase()}
            </LocalizedLink>
          </Button>
        </li>
      ))}
    </ol>
  );
};
